import React, { useState, useEffect,  createContext } from 'react';

import './Toggle.css';

function Toggle(props: {
    initialToggleState: boolean;
    onToggle?: (state: boolean) => void;
    children: React.ReactNode|React.ReactNode[];
}) {
    let [isOn, setIsOn] = useState(props.initialToggleState);
    const onCheckboxToggle = (e: any) => setIsOn(e.target.checked);
    let bgClasses = isOn ? 'bg-logo-green' : 'bg-light-grey';
    useEffect(() => {
        if (props.onToggle) {
            props.onToggle(isOn);
        }
    }, [isOn, props]);
    return (
        <label className="flex items-center cursor-pointer">
            <div className="relative">
                <input type="checkbox" className="toggle sr-only" onChange={onCheckboxToggle} checked={isOn} />
                <div className={`${bgClasses} block w-14 h-8 rounded-full`}></div>
                <div className="dot absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition"></div>
            </div>
            <div className="ml-3 text-gray-700 font-medium">{props.children}</div>
        </label>
    );
}
export default Toggle;